import { isValid, parse } from 'date-fns';

export const parseGermanDate = (dateValue: Date | string): Date => {
    if (dateValue instanceof Date) {
        return dateValue;
    }

    if (typeof dateValue === 'string') {
        const germanDateRegex = /^\d{1,2}\.\d{1,2}\.\d{4}$/;

        if (germanDateRegex.test(dateValue)) {
            const parsedDate = parse(dateValue, 'dd.MM.yyyy', new Date());
            if (isValid(parsedDate)) {
                return parsedDate;
            }
        }

        return new Date(dateValue);
    }

    return new Date(dateValue);
};
